// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BACK_TO_BAZAAR_GRID = "Sp\u00e4\u0165 na inzer\u00e1ty";
export const BZ2_counter_PRODUCTS = ["%(counter)s inzer\u00e1t", "%(counter)s inzer\u00e1ty", "%(counter)s inzer\u00e1tov"];
export const BZ2_ONLY_NOT_MARKED = "Iba neskontrolovan\u00e9";
export const BZ2_ONLY_REPORTED = "Iba nahl\u00e1sen\u00e9";
export const PROFILE_username_BLOCKED_BY_USER = "Pou\u017e\u00edvate\u013eka %(username)s u\u017e nem\u00e1 \u00fa\u010det na Modrom kon\u00edku. K tomuto kroku sa rozhodla sama pou\u017e\u00edvate\u013eka.";
